import {
  InputGroup,
  InputRightElement,
  NumberInput,
  NumberInputField,
  Text,
} from "@chakra-ui/react";
import { InputWrapper, InputWrapperProps } from "components/inputs/FormInputs";
import { useController } from "react-hook-form";

export const NumberFormInput = ({
  id,
  min = -Infinity,
  max = Infinity,
  invalidInputCharacters = ["e"],
  ...rest
}: InputWrapperProps & {
  min?: number;
  max?: number;
  invalidInputCharacters?: string[];
}) => {
  const {
    field: { onChange, ...field },
  } = useController({ name: id });
  return (
    <InputWrapper id={id} {...rest}>
      <NumberInput
        onChange={(valueAsString, valueAsNumber) => {
          if (
            valueAsString.length <= 0 ||
            invalidInputCharacters.some(
              (character) => valueAsString.indexOf(character) >= 0
            )
          ) {
            return;
          }
          onChange({
            target: {
              value: valueAsNumber,
            },
          });
        }}
        {...field}
        min={min}
        max={max}
      >
        <InputGroup>
          <NumberInputField />
          {rest.uom && (
            <InputRightElement>
              <Text>{rest.uom}</Text>
            </InputRightElement>
          )}
        </InputGroup>
      </NumberInput>
    </InputWrapper>
  );
};

export default NumberFormInput;
